export default __webpack_public_path__ + "static/media/hengel.c9844a12.png";